angular.module('impactx.contentservicebrowser').controller('ChangeSupplierDialogCtrl', ['$scope', '$mdDialog', 'TranslationService', 'dataGen', 'themeFactory',
    'header', 'inputLabel', ChangeSupplierDialogCtrl]);

function ChangeSupplierDialogCtrl($scope, $mdDialog, TranslationService, dataGen, themeFactory, header, inputLabel)
{
    $scope.saveLabel = TranslationService.get("save");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.theme = themeFactory.getTheme();
    $scope.header = header;
    $scope.inputLabel = inputLabel;
    $scope.supplierid = {value: ""};
    var self = this;

    self.cancel = function() {
        $mdDialog.cancel();
    };
    self.answer = function() {
        $mdDialog.hide($scope.supplierid.value);
    };

    this.getSupplierEntries = function(searchText)
    {
        return dataGen.getData({}, {searchText: searchText}, "/contentservicebrowser/suppliers", null, true).then(function(data) {
            return data.data.entries;
        });
    };

}
